export default __webpack_public_path__ + "static/media/home_device_icon.f8e8f243.svg";